import { axiosInstance } from "./api";

export default {
  getAgrodata_30_sByGalpon: gwtoken => {
    return axiosInstance.get(`agrodata-30-s?$latest=true&gwtoken=${gwtoken}`);
  },
  getAgrodata_1_mByGalpon: gwtoken => {
    return axiosInstance.get(`agrodata-1-m?$latest=true&gwtoken=${gwtoken}`);
  },
  getAgrodata_1_hByGalpon: gwtoken => {
    return axiosInstance.get(`agrodata-1-h?$latest=true&gwtoken=${gwtoken}`);
  },
  getAgrodata_1_dByGalpon: gwtoken => {
    return axiosInstance.get(`agrodata-1-d?$latest=true&gwtoken=${gwtoken}`);
  },
  getAgrodata_ac_byGalpon: gwtoken => {
    return axiosInstance.get(`agrodata-ac?$latest=true&gwtoken=${gwtoken}`);
  },
  getVariablesByGalpon: gwtoken => {
    return axiosInstance.get("datastore?$lastupdate=true&gwtoken=" + gwtoken);
  },
  getVistaVariablesByGalpon: gwtoken => {
    return axiosInstance.get("dsviews?$vvctrlproc=true&gwtoken=" + gwtoken);
  },
  getInicioCampaniaByGalpon: gwtoken => {
    return axiosInstance.get(
      `log-rel-version-ic?$limit=1&$sort[corr]=-1&gwtoken[$in][]=${gwtoken}`
    );
  }
  // getVariablesByPlantel: plantelId => {
  //   return axiosInstance.get(
  //     "datastore?$getAllVarsProcesoByPlantel=true&plantelId=" + plantelId
  //   );
  // }
};
